<template>
    <div class="register-page">
        <div class="floating-icons-container">
        <!-- Floating icons will be generated here -->
        </div>

        <div class="register-container">
    
    <TourialLogo />
    <div style="width: 100%;">
        <h3 class="bold">{{ $t('register.title') }}</h3>
    </div>
    
    <p class="info-box">
        <i class="bx bx-crown bx-sm"></i>
        
        Per procedere al pagamento, è necessario essere registrati.
        Inserisci qui la tua mail:
    </p>

    <form style="margin-top: 10px;">
        <TransitionGroup name="slide-down" mode="out-in" style="gap:10px; display: flex; flex-direction: column;">

        <vs-input block key="name" :placeholder="$t('common.name')" v-model="name" v-on:keyup.enter="registerEvent" v-if="signupMode"/>
        <vs-input block key="surname" :placeholder="$t('common.surname')" v-model="surname" v-on:keyup.enter="registerEvent" v-if="signupMode"/>
        <vs-input key="email" block :placeholder="$t('common.email')" v-model="email" type="email" v-on:keyup.enter="registerEvent" />
        <vs-input key="password" block type="password" :placeholder="$t('common.password')" v-model="password" v-on:keyup.enter="registerEvent" v-if="signinMode || signupMode"/>
        <vs-input key="rpassword" block type="password" :placeholder="$t('common.confirmPassword')" v-model="rpassword" v-on:keyup.enter="registerEvent" v-if="signupMode"/>
        <div v-if="signupMode" key="agreements">
            <vs-checkbox v-model="acceptAll">
                {{ $t('register.acceptAll') }}
            </vs-checkbox>

            <vs-checkbox v-model="tosAgreement">
                <a  @click="showTos">{{ $t('register.acceptTermsOfService') }}</a>
            </vs-checkbox>
            <vs-checkbox v-model="privacyAgreement">
                <a  @click="showPrivacyPolicy">{{ $t('register.acceptPrivacyPolicy') }}</a>
            </vs-checkbox>
            <vs-checkbox v-model="want_newsletter">
                {{ $t('profile.keepMeUpdated') }}
            </vs-checkbox>
        </div>
        </TransitionGroup>
    </form>

    <vs-button v-if="signupMode" size="large" block class="bold animate" @click="registerEvent" :loading="loading">{{ $t('register.signUp').toUpperCase() }}</vs-button>
    <vs-button v-else-if="signinMode" size="large" block class="bold animate" @click="loginEvent" :loading="loading">{{ $t('login.signIn').toUpperCase() }}</vs-button>
    <vs-button v-else size="large" block class="bold animate" @click="checkUser" :loading="loading">{{ $t('common.next').toUpperCase() }}</vs-button>
    

    <p class="center" v-if="signupMode">
        {{ $t('register.alreadyHaveAnAccount')  }}
        <a @click="signinMode = false; signupMode = false; email = '';" to="/explore/login">{{ $t('register.signIn') }}</a>
    </p>

    <p class="center" v-if="enabledFeatures['signInWithGoogle'] !== false">
        {{ $t('login.signInWith') }}
    </p>

    <vs-button transparent size="large" :loading="googleLoading" @click="signInWithGoogle" v-if="enabledFeatures['signInWithGoogle'] !== false"><img src="../../assets/icons/google.png" /></vs-button>
    <DialogWrapper v-if="component != null" :component="component" :is-mobile="$parent.$parent.isMobile" @close="() => {component = null}" :blur="false" />
    <Footer/>

</div>
    </div>

</template>

<script>

import TourialLogo from '../TourialLogo.vue'
import {
    apiCall,
    hash
} from '../../utils/ApiMiddleware';
import DialogWrapper from '../DialogWrapper.vue';

import Footer from '../Footer.vue';
import {
    baseUri
} from '../../utils/ApiMiddleware';

// Import target icons
// Import target icons
import icon1 from '../../assets/targets-test/4b294a18-45e8-446f-a2d4-e87e7fc7f655.png';
import icon2 from '../../assets/targets-test/4c058958-dca9-4b81-9c59-2001020ec687.png';
import icon3 from '../../assets/targets-test/4d10226f-8e2f-47ab-8e5d-2e31b4c70493.png';
import icon4 from '../../assets/targets-test/80a653f6-7f00-457e-859e-376449ee0e6a.png';
import icon5 from '../../assets/targets-test/8578e0e2-d2de-4e4f-92a9-7d6a0e359bc0.png';
import icon6 from '../../assets/targets-test/9a11042b-ab43-4d51-b1a3-324212bd6ee3.png';
import icon7 from '../../assets/targets-test/9f004d7f-cb06-48ed-963f-08893d72a04b.png';
import icon8 from '../../assets/targets-test/a9f83fcc-1df9-44b3-8b80-256584b42aff.png';
import icon9 from '../../assets/targets-test/aa9061b6-deff-4336-8dbe-294fcfe7a61a.png';
import icon10 from '../../assets/targets-test/e2c2ab90-21dc-4e8f-a392-1b669f5968aa.png';
import icon11 from '../../assets/targets-test/e4f45c42-340b-4550-8fbf-57a4d4266297.png';

export default {
    name: "register",
    props: {},
    components: {
        TourialLogo,
        DialogWrapper,
        Footer,
    },

    data() {
        return {
            name: '',
            surname: '',
            email: '',
            password: '',
            rpassword: '',
            want_newsletter: false,
            tosAgreement: false,
            privacyAgreement: false,
            language_id: 0,
            loading: false,
            component: null,
            googleLoading: false,
            acceptAll: false,

            signupMode: false,
            signinMode: false,

            targetIcons: [icon1, icon2, icon3, icon4, icon5, icon6, icon7, icon8, icon9, icon10, icon11],
            floatingIcons: [],
        }
    },

    methods: {
        async checkUser(){
            // we try to login, if ti gives 404 as status code it doesnt exist, otherwise it exists 
            const response = await apiCall('POST', '/users/login', {
                email: this.email,
                password: hash(''),
            }, true);

            if (response.status == 404) {
                this.signupMode = true;
                this.signinMode = false;
            } else {
                this.signupMode = false;
                this.signinMode = true;
            }
        },

        async signInWithGoogle() {
            this.googleLoading = true;
            setTimeout(() => {
                this.googleLoading = false;
                window.location.href = baseUri + '/auth/external?provider=google&is_app=' + JSON.stringify(this.$IS_APP) + (this.$IS_APP ? '&duration=15552000000000000' : '');
            }, 1000);
        },

        showTos(e) {
            e.preventDefault();
            this.$router.push('/tos');
        },

        showPrivacyPolicy(e) {
            e.preventDefault();
            this.$router.push('/privacy-policy');
        },

        async loginEvent() {
            this.loading = true;
            await this.login();
            this.loading = false;
        },

        async login() {
            // use apiCall to call the login api
            const response = await apiCall('POST', '/users/login', {
                email: this.email,
                password: hash(this.password),
                duration: this.$IS_APP ? 15552000000000000 : undefined, // it's in nanosecond, 180 days
            });
            // if status code is 200, show a success message and redirect to the explore page, otherwise show an error message
            if (response.status == 200) {
                /*this.$vs.notification({
                    title: this.$t('login.title'),
                    text: this.$t('login.messages.success'),
                    color: 'success',
                    position: 'top-right'
                });*/
                window.location.href = '/explore/profile/subscription';
            } else if (response.status != 0) { // 0 is an already handled error, no needs to show another error message
                this.$vs.notification({
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('login.messages.error'),
                    color: 'danger',
                    position: 'top-right'
                });
            }
        },

        async registerEvent() {
            this.loading = true;
            await this.register();
            this.loading = false;
        },
        async register() {

            // language setting
            var lang = navigator.language || navigator.userLanguage;
            if (lang != null && lang != '') {
                lang = lang.split('-')[0].toUpperCase();
            }

            const languagesResponse = await apiCall('GET', '/users/languages');
            if (languagesResponse.status != 200) {
                this.$vs.notification({
                    color: 'danger',
                    position: 'top-right',
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('register.messages.cannotRegister')
                })
                return;
            }

            var languageMatch = languagesResponse.data.language.find(x => x.name == lang);
            if (languageMatch != null) {
                this.language_id = languageMatch.id;
            } else {
                this.language_id = languagesResponse.data.language.find(x => x.name == 'EN');
            }

            if (this.password != this.rpassword) {
                this.$vs.notification({
                    color: 'danger',
                    position: 'top-right',
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('register.messages.passwordMismatch')
                })
                return;
            }

            // if tos agreement are not acecepted, show an error message
            if (!this.tosAgreement) {
                this.$vs.notification({
                    color: 'danger',
                    position: 'top-right',
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('register.messages.mustAcceptTerms')
                })
                return;
            }

            // if privacy agreement are not acecepted, show an error message
            if (!this.privacyAgreement) {
                this.$vs.notification({
                    color: 'danger',
                    position: 'top-right',
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('register.messages.mustAcceptPrivacy')
                })
                return;
            }

            // if password is not enought strong show an error message
            if (this.password.length < 8) {
                this.$vs.notification({
                    color: 'danger',
                    position: 'top-right',
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('register.messages.passwordTooShort')
                })
                return;
            }

            var link_id = this.$cookie.get('TOURIAL-C');

            const response = await apiCall('POST', '/users/register', {
                name: this.name,
                surname: this.surname,
                email: this.email,
                password: hash(this.password),
                language_id: this.language_id,
                want_newsletter: this.want_newsletter,
                link_id
            });

            // if status code is ok, show a success message
            if (response.status == 200) {
                this.$vs.notification({
                    color: 'success',
                    position: 'top-right',
                    title: this.$t('common.messages.success'),
                    text: this.$t('register.messages.registered')
                })

                // login
                // use apiCall to call the login api
                const loginResponse = await apiCall('POST', '/users/login', {
                    email: this.email,
                    password: hash(this.password),
                    duration: this.$IS_APP ? 15552000000000000 : undefined, // it's in nanosecond, 180 days
                });
                // if status code is 200, show a success message and redirect to the explore page, otherwise show an error message
                if (loginResponse.status == 200) {
                    /*this.$vs.notification({
                        title: this.$t('login.title'),
                        text: this.$t('login.messages.success'),
                        color: 'success',
                        position: 'top-right'
                    });*/
                    
                    window.location.href = '/explore/profile/subscription';
                } else if (loginResponse.status != 0) { // 0 is an already handled error, no needs to show another error message
                    this.$vs.notification({
                        title: this.$t('common.messages.somethingWentWrong'),
                        text: this.$t('login.messages.error'),
                        color: 'danger',
                        position: 'top-right'
                    });
                }
            } else if (response.status == 409) {
                // show an error message saying that is already registered
                this.$vs.notification({
                    color: 'danger',
                    position: 'top-right',
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('register.messages.emailAddressAlreadyUsed')
                })
            } else if (response.status != 0) { // 0 is an already handled error, no needs to show another error message
                // if status code is not ok, show an error message
                this.$vs.notification({
                    color: 'danger',
                    position: 'top-right',
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('register.messages.cannotRegister')
                })
            }

        },

        createFloatingIcons() {
            const container = document.querySelector('.floating-icons-container');
            if (!container) return;
            
            // Clear any existing icons
            container.innerHTML = '';
            
            // Create 15 floating icons
            for (let i = 0; i < 10; i++) {
                this.createSingleFloatingIcon(container);
            }
            
            // Continue adding new icons periodically
            setInterval(() => {
                if (this.floatingIcons.length < 100) {
                    this.createSingleFloatingIcon(container);
                }
            }, 700);
        },
        
        createSingleFloatingIcon(container) {
            // Create icon element
            const icon = document.createElement('img');
            
            // Random icon selection
            const randomIcon = this.targetIcons[Math.floor(Math.random() * this.targetIcons.length)];
            icon.src = randomIcon;
            
            // Add class
            icon.classList.add('floating-icon');
            
            // Random positioning and animation properties
            const size = 50 + Math.random() * 20; // Random size between 20px and 60px
            const startPosition = Math.random() * 100; // Random horizontal position (0-100%)
            const duration = 15 + Math.random() * 20; // Random duration (15-35s)
            const xShift = -50 + Math.random() * 100; // Random horizontal drift (-50px to 50px)
            const rotation = -90 + Math.random() * 180; // Random rotation (-180deg to 180deg)
            
            // Apply styles
            icon.style.width = `${size}px`;
            icon.style.height = `${size}px`;
            icon.style.left = `${startPosition}%`;
            icon.style.bottom = '-60px';
            icon.style.setProperty('--x-shift', `${xShift}px`);
            icon.style.setProperty('--rotation', `${rotation}deg`);
            icon.style.animation = `floatUp ${duration}s linear forwards`;
            
            // Add to container
            container.appendChild(icon);
            
            // Track the icon
            this.floatingIcons.push(icon);
            
            // Remove from array when animation completes
            setTimeout(() => {
                const index = this.floatingIcons.indexOf(icon);
                if (index > -1) {
                    this.floatingIcons.splice(index, 1);
                }
                // Remove from DOM
                if (icon.parentNode) {
                    icon.parentNode.removeChild(icon);
                }
            }, duration * 1000);
        }
    },

    watch: {
        acceptAll(n){
            if(n){
                this.tosAgreement = true;
                this.privacyAgreement = true;
                this.want_newsletter = true;
            }
        }
    },
    computed: {
        enabledFeatures() {
            return this.$FEATURES.settings;
        },
    },

    mounted(){
        console.log(this.$TARGETS);
        this.createFloatingIcons();
    }
}
</script>

<style scoped>
.register-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    height: 100%;
    padding: 0;
    margin: 0;
    position: relative; /* Add position relative for absolute positioning of children */
}

.floating-icons-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: -1; /* Position behind the form */
    pointer-events: none; /* Ensure clicks pass through to elements behind */
}


/* DESKTOP */
@media (min-width: 1024px) {
    .register-container {
        width: 350px;
    }
}

/* MOBILE */
@media (max-width: 600px) {
    .register-container {
        justify-content: center;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
        padding-bottom: 80px !important;
        width: 100% !important;
    }
}
.info-box {
    padding: 10px; 
    border: 1px solid rgba(var(--vs-primary), 0.5); 
    border-radius: 5px; 
    background: rgba(var(--vs-primary), 0.01); 
    color: rgba(var(--vs-primary)); 
    /* blur background */
    background-color: rgba(255, 255, 255, 0.75);
    backdrop-filter: blur(5px);
    
    /* Add flex layout */
    display: flex;
    align-items: center; /* Vertically center the icon and text */
    gap: 12px; /* Space between icon and text */
}

/* Optional: Add a slight emphasis to the icon */
.info-box i {
    flex-shrink: 0; /* Prevent icon from shrinking */
    color: rgba(var(--vs-primary), 1); /* Make icon slightly darker than text */
}
</style>
<style>

.floating-icon {
    position: absolute;
    opacity: 0.2;
    transform-origin: center;
    width: 40px;
    height: 40px;
    will-change: transform, opacity;
}

@keyframes floatUp {
    0% {
        transform: translateY(100%) translateX(0) rotate(0deg);
        opacity: 0.8;
    }
    10% {
        opacity: 1;
    }
    90% {
        opacity: 1;
    }
    100% {
        transform: translateY(-2000%) translateX(var(--x-shift)) rotate(var(--rotation));
        opacity: 0.1;
    }
}

.route-Registrati {
    height: 100%;
}
</style>